"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.useQueryParams = exports.parseQueryParam = exports.QueryParamTypes = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _reactRouter = require("react-router");

var _queryString = _interopRequireDefault(require("query-string"));

var _moment = _interopRequireDefault(require("moment"));

var QueryParamTypes = {
  Array: 'array',
  Date: 'date',
  Int: 'int'
};
exports.QueryParamTypes = QueryParamTypes;

var parseQueryParam = function parseQueryParam(queryParam, type) {
  switch (type) {
    case QueryParamTypes.Array:
      if (queryParam instanceof Array) {
        return queryParam;
      } else if (queryParam) {
        return [queryParam];
      }

      return [];

    case QueryParamTypes.Date:
      if (queryParam) {
        return (0, _moment.default)(queryParam).toDate();
      }

      return queryParam;

    case QueryParamTypes.Int:
      if (queryParam) {
        return parseInt(queryParam);
      }

      return queryParam;

    default:
      return queryParam;
  }
};

exports.parseQueryParam = parseQueryParam;

var useQueryParams = function useQueryParams(schema) {
  var location = (0, _reactRouter.useLocation)();

  var queryParams = _queryString.default.parse(location.search);

  if (schema) {
    return Object.keys(queryParams).reduce(function (typedQueryParams, queryParamKey) {
      var _extends2;

      return (0, _extends3.default)({}, typedQueryParams, (_extends2 = {}, _extends2[queryParamKey] = parseQueryParam(queryParams[queryParamKey], schema[queryParamKey]), _extends2));
    }, {});
  }

  return queryParams;
};

exports.useQueryParams = useQueryParams;
var _default = useQueryParams;
exports.default = _default;